import React, { useState, useCallback } from 'react';
import StationPlanner2D from './components/StationPlanner2D';

const StationPlannerPage = () => {
  const [currentStation, setCurrentStation] = useState('G1');
  const [elements, setElements] = useState([]);
  const [user] = useState({ id: 1, name: 'Test User' }); // Mock user

  const handleElementsChange = useCallback((newElements) => {
    setElements(newElements);
  }, []);

  const handleSave = useCallback(async (station, data) => {
    console.log('💾 Saving station:', station, 'with data:', data);
    
    try {
      const response = await fetch(`/api/station-layouts/${station}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      
      if (response.ok) {
        console.log('✅ Save successful');
        return await response.json();
      } else {
        console.error('❌ Save failed:', response.status);
        throw new Error('Fehler beim Speichern');
      }
    } catch (error) {
      console.error('❌ Save error:', error);
      throw error;
    }
  }, []);

  const stations = ['G1', 'G5', 'G8', 'G10'];

  return (
    <div className="container-fluid py-4" style={{ height: '100vh' }}>
      <div className="row mb-3">
        <div className="col">
          <h1 className="h3 mb-0">Station Planner 2D</h1>
          <div className="mt-2">
            <label className="form-label">Station auswählen:</label>
            <select 
              className="form-select" 
              style={{ width: 'auto', display: 'inline-block' }}
              value={currentStation}
              onChange={(e) => setCurrentStation(e.target.value)}
            >
              {stations.map(station => (
                <option key={station} value={station}>{station}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      
      <div className="row" style={{ height: 'calc(100vh - 120px)' }}>
        <div className="col">
          <StationPlanner2D
            station={currentStation}
            initialElements={elements}
            onElementsChange={handleElementsChange}
            onSave={handleSave}
            user={user}
          />
        </div>
      </div>
    </div>
  );
};

export default StationPlannerPage;